import { render, staticRenderFns } from "./LanguageDropdown.vue?vue&type=template&id=de432ef2&scoped=true"
import script from "./LanguageDropdown.vue?vue&type=script&lang=js"
export * from "./LanguageDropdown.vue?vue&type=script&lang=js"
import style0 from "./LanguageDropdown.vue?vue&type=style&index=0&id=de432ef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de432ef2",
  null
  
)

export default component.exports